import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { CookieService } from '../service/cookie.service';

export const chooseCompanyGuard: CanActivateFn = async (route, state) => {
  
  console.log("Choose Company gaurd called");
  
  const cookieService = inject(CookieService);
  const router = inject(Router);

  const selectedCompanyId = cookieService.getCookie('selectedCompanyId');
  console.log('Found Cookie', selectedCompanyId);
  
  if(selectedCompanyId) return true
  router.navigate(['/choose_company'])
  return false
};